<template>
    <canvas :height="computedCanvasHeight" ref="canvas" :class="[computedChartClass]"></canvas>
</template>

<script>
    import Chart from '../../utils/chart';
    import { nanoid } from '../../utils';
    
    export default {
        name: 'd-small-stats',
        props: {
            chartData: {
                type: Array,
                required: true,
                default() {
                    return [];
                },
            },
        },

        computed: {
            computedChartClass() {
                return `transaction-blocks` || `stats-small-${nanoid()}`;
            },

            computedCanvasHeight() {
                return 60;
            }
        },

        methods: {
            renderChart() {
                const chartOptions = {
                    ...{
                        maintainAspectRatio: true,
                        responsive: true,
                        legend: {
                            display: false,
                        },
                        tooltips: {
                            enabled: false,
                            custom: false,
                        },
                        elements: {
                            point: {
                                radius: 0,
                            },
                            line: {
                                tension: 0.33,
                            },
                        },
                        scales: {
                            xAxes: [{
                                gridLines: false,
                                ticks: {
                                    display: false,
                                },
                            }],
                            yAxes: [{
                                gridLines: false,
                                scaleLabel: false,
                                ticks: {
                                    display: false,
                                    isplay: false,
                                    // Avoid getting the graph line cut of at the top of the canvas.
                                    // Chart.js bug link: https://github.com/chartjs/Chart.js/issues/4790
                                    suggestedMax: Math.max(...this.chartData[0].data) + 1,
                                },
                            }],
                        },
                    },
                    ...this.chartOptions,
                };

                const chartConfig = {
                    ...{
                        type: 'line',
                        data: {
                            ...{ labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ] },
                            ...{
                                datasets: this.chartData,
                            },
                        },
                        options: chartOptions,
                    },
                    ...this.chartConfig,
                };
                
                this.chart = new Chart(this.$refs.canvas, chartConfig);
            }
        },

        watch: {
            // Runs after chartData is changed
            chartData() {
                this.renderChart()
            }
        }
    };
    </script>